import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-89bdf77a")

_pushScopeId("data-v-89bdf77a")
const _hoisted_1 = { class: "shell info-container info-padding" }
const _hoisted_2 = { class: "info-light-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "info-item info-item-bottom"
}
const _hoisted_5 = { class: "info-label-title" }
const _hoisted_6 = { class: "info-label-content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "info-item info-item-bottom" }
const _hoisted_9 = { class: "info-label-title" }
const _hoisted_10 = { class: "info-label-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_device_info_setting_dialog = _resolveComponent("device-info-setting-dialog")
  const _component_jump_page = _resolveComponent("jump-page")
  const _component_loading_animation_dialog = _resolveComponent("loading-animation-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumbHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailForm, (item, index) => {
        return (_openBlock(), _createBlock("div", { key: item }, [
          (item.type === _ctx.titleType)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: 
                            index === 0
                                ? 'flex1 display-flex justify-content-between info-title-havbutton-bottom'
                                : 'info-title-bottom margin-top30px'
                        
              }, [
                _createVNode("b", _hoisted_2, _toDisplayString(item.label), 1),
                (index === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode(_component_cus_button, {
                        onClick: _ctx.remote,
                        class: "margin-right10px"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextRemoteControl), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_cus_button, {
                        type: "blue",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowDeviceInfoSettingDialog = true))
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextSetting), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : (item.type === _ctx.labelType || item.type === _ctx.labelCustomize)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("label", _hoisted_5, _toDisplayString(item.label) + ":", 1),
                  _createVNode("label", _hoisted_6, _toDisplayString(item.text ? item.text : "--"), 1)
                ]))
              : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                  (_ctx.IsShowBuildNames)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("div", _hoisted_8, [
                          _createVNode("label", _hoisted_9, _toDisplayString(item.label) + ":", 1),
                          _createVNode("label", _hoisted_10, _toDisplayString(item.text ? item.text : "--"), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
        ]))
      }), 128))
    ]),
    (_ctx.isShowDeviceInfoSettingDialog)
      ? (_openBlock(), _createBlock(_component_device_info_setting_dialog, {
          key: 0,
          initForm: _ctx.deviceDetail,
          onClose: _ctx.closeInfo,
          projectType: _ctx.projectType
        }, null, 8, ["initForm", "onClose", "projectType"]))
      : _createCommentVNode("", true),
    (_ctx.isShowJumpPage)
      ? (_openBlock(), _createBlock(_component_jump_page, {
          key: 1,
          "jump-url": _ctx.jumpUrl,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowJumpPage = false))
        }, null, 8, ["jump-url"]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading_animation_dialog, {
      isShowLoadingDialog: _ctx.isShowLoadingDialog,
      title: _ctx.$wordList.ProperAllTextRemoteControl,
      content: _ctx.$wordList.InitiatingConnectionTip,
      onClose: _ctx.closeLoadingDialog
    }, null, 8, ["isShowLoadingDialog", "title", "content", "onClose"])
  ]))
})